import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Button, Table } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import may from 'js/security';
import {
  deleteSubscriptionPriceR,
  deactivateSubscriptionPriceR,
  activateSubscriptionPriceR,
} from 'actions/SubscriptionPricesActions';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { getNameInCurrentLanguage } from 'helpers/intl';
import FormSwitchery from 'components/forms/FormSwitchery';
import { ROLE_ADMIN } from 'js/constants';
import List from 'components/List';

import Breadcrumb from '../Breadcrumb';
import SimplePrompt from '../SimplePrompt';
import Loader from '../Loader';
import ClientSubscriptionNew from './ClientSubscriptionNew';
import ClientSubscriptionEdit from './ClientSubscriptionEdit';
import IntlDateTime from '../IntlDateTime';

class ClientSubscriptions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showNew: false,
      showEdit: false,
      subscriptionPriceId: '',
    };
  }

  openAddClientSubscription = () => {
    this.setState({ showNew: true });
  };

  closeAddClientSubscription = () => {
    this.setState({ showNew: false });
  };

  openEditClientSubscription = subscriptionPriceId => {
    this.setState({ subscriptionPriceId, showEdit: true });
  };

  deleteSubscriptionPrice = id => {
    const { deleteSubscriptionPriceR } = this.props;
    deleteSubscriptionPriceR(id);
  };

  closeEditClientSubscription = () => {
    this.setState({ showEdit: false });
  };

  translateSubscription = subscriptionPrice => {
    const {
      appIntl: { locale },
    } = this.props;

    const { subscription } = subscriptionPrice;
    if (!subscription) {
      console.error(this.constructor.name, 'subscription misses description', subscriptionPrice);

      return '';
    }
    const { description } = subscription;
    const matchingDescription = description.find(({ lang }) => lang === locale) ?? description[0];

    return matchingDescription?.description || ''; // or name
  };

  deactivateSubscription = subscriptionPrice => {
    const { deactivateSubscriptionPriceR } = this.props;
    const { id } = subscriptionPrice;
    deactivateSubscriptionPriceR(id, subscriptionPrice);
  };

  activateSubscription = subscriptionPrice => {
    const { activateSubscriptionPriceR } = this.props;
    const { id } = subscriptionPrice;
    activateSubscriptionPriceR(id, subscriptionPrice);
  };

  translateItemName = item => {
    if (!item) {
      return '';
    }
    const { name } = item;
    if (!name) {
      return '';
    }
    const { appIntl } = this.props;

    return typeof name === 'object' ? getNameInCurrentLanguage(name, appIntl) : name;
  };

  getBreadcrumb = () => {
    const {
      intl: { messages },
      appIntl: { urlPrefix },
    } = this.props;

    const crumbs = [
      { link: urlPrefix + 'account', name: 'Dashboard' },
      { link: urlPrefix + 'account/settings', name: messages.settings },
      { link: null, name: messages.client_subscription_settings },
    ];

    return <Breadcrumb crumbs={crumbs} className="p-t-0" />;
  };

  render() {
    const {
      intl: { messages },
      appIntl: { urlPrefix },
      subscriptionPrices,
      user,
    } = this.props;
    const { showNew, showEdit, subscriptionPriceId } = this.state;
    const columns = [
      messages.subscription_name,
      messages.subscription_type,
      messages.subscription_description,
      messages.subscription_clients + ' - ' + messages.subscription_items,
      messages.subscription_fee,
      messages.subscription_startingFee,
      messages.subscription_start,
      messages.subscription_end,
      messages.subscription_status,
      messages.subscription_action,
    ];

    const { roles } = user;
    const tBody = [];

    const {
      data: { list },
      pending,
    } = subscriptionPrices;

    list.forEach(subscriptionPrice => {
      const {
        client,
        id,
        subscription,
        item,
        period_start: periodStart,
        period_end: periodEnd,
        is_active: isActive,
        fee,
        starting_fee: startingFee,
        target_type: targetType,
        meta_data: { desired_domain: desiredDomain, order_id: orderId, edition_id: editionId },
      } = subscriptionPrice;

      let profile = '';
      if (client) {
        const { type, profile: clientProfile } = client;
        if (type === 'employee') {
          const { first_name: firstName, last_name: lastName } = clientProfile;
          profile = `${firstName} ${lastName}`;
        } else if (type === 'customer') {
          profile = clientProfile.company;
        }
      }
      let metaDataDetails = [<span>{this.translateSubscription(subscriptionPrice)}</span>];

      if (desiredDomain) {
        if (metaDataDetails.length > 0) {
          metaDataDetails.push(<br />);
        }
        metaDataDetails.push(
          <a href={`https://${desiredDomain}`} target="_blank" rel="noopener noreferrer">
            {desiredDomain}
          </a>
        );
      }
      if (orderId) {
        if (metaDataDetails.length > 0) {
          metaDataDetails.push(<br />);
        }
        metaDataDetails.push(<Link to={urlPrefix + 'account/orders/' + orderId}>{messages.order}</Link>);
      }
      if (editionId) {
        if (metaDataDetails.length > 0) {
          metaDataDetails.push(<br />);
        }
        metaDataDetails.push(
          <Link to={urlPrefix + 'account/editor/' + editionId}>{messages.campaign.edition_item}</Link>
        );
      }

      let type = targetType !== subscription?.type && subscription?.type === 'item' ? targetType : subscription?.type;

      tBody.push(
        <tr key={id}>
          <td class="v-align-middle">
            <span>{subscription?.name}</span>
          </td>
          <td className="v-align-middle">
            <span>{type}</span>
          </td>
          <td className="v-align-middle">{metaDataDetails}</td>
          <td className="v-align-middle">
            <span>
              {profile} {this.translateItemName(item)}
            </span>
          </td>
          <td className="v-align-middle">
            <span>{fee}</span>
          </td>
          <td className="v-align-middle">
            <span>{startingFee}</span>
          </td>
          <td className="v-align-middle">
            <span>
              <IntlDateTime date={periodStart} />
            </span>
          </td>
          <td className="v-align-middle">
            <span>
              <IntlDateTime date={periodEnd} />
            </span>
          </td>
          <td className="v-align-middle subscriptionStatus">
            <FormSwitchery
              name="status"
              label=""
              value
              checked={!!isActive}
              onChange={(name, value) =>
                value ? this.activateSubscription(subscriptionPrice) : this.deactivateSubscription(subscriptionPrice)
              }
              // disabled={!isActive /* can only deactivate: one-way */}
            />
          </td>
          <td class="v-align-middle text-right">
            {may(ROLE_ADMIN, roles) && (
              <>
                <SimplePrompt className="m-l-5 m-t-5 m-b-5" onSuccess={() => this.deleteSubscriptionPrice(id)} />
                <Button
                  onClick={() => this.openEditClientSubscription(id)}
                  bsStyle="warning"
                  className="pull-right m-l-5 m-t-5 m-b-5"
                  title="create_subscription"
                >
                  <i className="far fa-edit" />
                  <span className="hidden-xs"> {messages.subscription_edit}</span>
                </Button>
              </>
            )}
          </td>
        </tr>
      );
    });

    return (
      <>
        <div className="padding-25 sm-padding-10">
          <List
            listName="subscriptionPrices"
            url="/api/subscriptions/prices/list/prices.json"
            // urlData={urlData}
            list={subscriptionPrices}
            title={messages.client_subscription_settings}
            iconClass="fad fa-repeat-alt"
            showNew
            newText={messages.add_subscription}
            newAction={this.openAddClientSubscription}
            showSearch={false}
            // sortOptions={['relevance,desc', 'cdate,desc', 'mdate,desc', 'priority,desc']}
            breadcrumb={this.getBreadcrumb()}
            metaIdentifier="Subscriptions:SubscriptionPrice"
            // displayTypes={['list', 'columns']}
            // activeDisplayType={displayType}
            // changeDisplayType={this.changeDisplayType}
            // filters={filters}
          >
            {pending ? (
              <Loader />
            ) : (
              <Table responsive hover>
                <thead>
                  <tr>
                    {columns.map(column => {
                      return (
                        <th key={column} className={column === messages.subscription_action ? 'text-right' : ''}>
                          {column}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <ReactCSSTransitionGroup
                  transitionName="tablerows"
                  transitionEnterTimeout={500}
                  transitionLeaveTimeout={1}
                  component="tbody"
                >
                  {tBody}
                </ReactCSSTransitionGroup>
              </Table>
            )}
          </List>
        </div>
        <div id="subscription-new">
          <ClientSubscriptionNew
            show={showNew}
            close={this.closeAddClientSubscription}
            closeAddClientSubscription={this.closeAddClientSubscription}
          />
        </div>

        <div id="subscription-edit">
          <ClientSubscriptionEdit
            show={showEdit}
            close={this.closeEditClientSubscription}
            closeEditClientSubscription={this.closeEditClientSubscription}
            subscriptionPriceId={subscriptionPriceId}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
    client: state.selectedClient.company,
    subscriptionPrices: state.list.subscriptionPrices,
  };
};

const mapDispatchToProps = {
  deleteSubscriptionPriceR,
  deactivateSubscriptionPriceR,
  activateSubscriptionPriceR,
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ClientSubscriptions)
  )
);
